import { updateObject, } from '../../utils/utility';
import { transformCountryVendorData } from '../../libs/data-transform';
const initialState = {
    quoteId: "",
    countryCode: null,
    quoteType: "",
    region: "",
    languageCode: "",
    orderType: 1,
    userId: "",
    firstName: "",
    lastName: "",
    customerName: "",
    email: "",
    contactNo: 1235,
    company: "",
    userType: "",
    shippingAddress: null,
    assetList: null,
    totalNetValue: null,
    amplifyProgram: null,
    status: "",
    createdDate: "",
    currencyCode: "",
    customerType: "",
    createdByEmail: null,
    createdByFirstName: null,
    createdByLastName: null,
    legalEntity: null,
    orgId: "",
    orderId: null,
    totalHpDeviceQuoted: null,
    totalDevicesQuoted: 10,
    hwBuyBackValue: null,
    serviceCost: null,
    selectedVendor: null,
    rateCardType: "",
    rateCardOption: "",
    rateCardSelection: "",
    priceListSelected: "",
    selectedServicePriceList: "",
    salesPersonEmail: "",
    contactPersonEmail: "",
    quoteCreationDate: "",
    selectVendorOption: "",
    requestDate: null,
    countryList: [],
    geographicalScope: "",
    ctResponsible: "",
    quoteValidDate: "",
    leadCountry: null,
    requestType: "",
    leadSource: "",
    leadOrigin: "",
    npsSurveySent: "",
    dateSurveySent: "",
    priceLists: [],
    servicePriceLists: [],
    countryCostMargins: [],
    countryVendors: [],
    requestorType: "",
    conversionRateType: "",
    customerFormOrgFileName: "",
    vendorSelectionData: [],
    vendorSelectionDataCopy: [],
    selectVendorOption: "country_coverage",
    vendorsList: [],
    vendorError: "",
    countryError: "",
    backButtonFlag: false,
    fileUploadStatus: "",
    fileUploadStatusDesc: "",
    selectedPriceList: "",
    directQuoteSaveSuccess: false,
    directQuoteSaveActionType: "",
    vendorMatrixSelections: [],
    vendorNetValues: [],
    paymentOnePointOneDefaultMargins: [],
    paymentOnePointODefaultMargins: [],
    paymentOnePointOneMarginData: [],
    paymentOnePointOMarginData: [],
    tableData: null,
    vendorQuoteDetails: [],
    countryVendorQuoteDetails: {},
    countryCurrency: {},
    shouldVendorListUpdate: false,
    updatedDate: "",
    quoteAcceptRejectDate: "",
    quotationSubmissionDate: "",
    selectedCountryVendor: {},
    selectedVendorMaxNetValue: "",
    convertedVendorNetValues: [],
    userSelectedTotalVendorNetValue: {},
    maxNetValue: [],
    revitalizeCountries: "",
    numberOfRevitalizeAssets: "",
    revitalizeHPPrices: "",
    hpFileUploadStatus: "",
    quoteType: "",
    priceService: {},
    refusedReasonList: [],
    vpartialPriceProvided: false,
    partialCreatedQuoteFileAvailable: false,
    fmvDetails: [],
    pyxtechCountryVendorDetails: [],
    refusedVendors: [],
    vendorAdditionalComments: {},
    internalHPComments: "",
    companyOrgIdEditable: false
}

const setCTInitialQuoteDetail = (state = initialState, action) => {
    const data = action.payload;
    return updateObject(state, {
        quoteId: data.quoteId || "",
        quoteType: data.quoteType || "",
        countryCode: data.countryCode || "",
        region: data.region || "",
        languageCode: data.languageCode || "",
        orderType: data.orderType || 1,
        userId: data.userId || "",
        firstName: data.firstName || "",
        lastName: data.lastName || "",
        customerName: data.company || "",
        email: data.email || "",
        contactNo: data.contactNo || "",
        company: data.company || "",
        userType: data.userType || "",
        shippingAddress: data.shippingAddress || null,
        assetList: data.assetList || null,
        totalNetValue: data.totalNetValue || null,
        amplifyProgram: data.amplifyProgram || null,
        status: data.status || "",
        createdDate: data.createdDate || "",
        currencyCode: data.currencyCode || "USD",
        customerType: data.customerType || "",
        createdByEmail: data.createdByEmail || null,
        createdByFirstName: data.createdByFirstName || null,
        createdByLastName: data.createdByLastName || null,
        legalEntity: data.legalEntity || null,
        requestType: data.requestType || "",
        leadSource: data.leadSource || "",
        leadOrigin: data.leadOrigin || "",
        npsSurveySent: data.npsSurveySent || "",
        dateSurveySent: data.dateSurveySent || "",
        orgId: data.orgId || "",
        orderId: data.orderId || null,
        totalHpDeviceQuoted: data.totalHpDeviceQuoted || null,
        totalDevicesQuoted: data.totalDevicesQuoted || 0,
        hwBuyBackValue: data.hwBuyBackValue || null,
        serviceCost: data.serviceCost || null,
        selectedVendor: data.selectedVendor || null,
        rateCardType: data.rateCardType || "",
        rateCardOption: data.rateCardOption || "",
        rateCardSelection: getRateCardSelection(data),
        selectedServicePriceList: data.servicePriceList && data.servicePriceList,
        salesPersonEmail: data.salesPersonEmail || "",
        contactPersonEmail: data.contactPersonEmail || "",
        quoteCreationDate: data.quoteCreationDate || "",
        requestDate: data.requestDate || null,
        countryList: data.countryList || [],
        geographicalScope: data.geographicalScope || "",
        ctResponsible: data.ctResponsible || "",
        quoteValidDate: data.quoteValidDate || "",
        leadCountry: data.leadCountry || null,
        priceLists: [],
        selectedPriceList: data.priceList || "",
        countryCostMargins: data.countryCostMargins || [],
        countryVendors: data.vendorQuoteDetails && data.countryVendors ? getVendorSelectedDetails(data.countryVendors, data.vendorQuoteDetails) : [],
        requestorType: data.requestorType || "",
        conversionRateType: data.conversionRateType || "",
        customerFormOrgFileName: data.customerFormOrgFileName || "",
        countriesRequested: data.countryList ? data.countryList.join(",") : "",
        vendorSelectionData: data.vendorQuoteDetails && data.countryVendors ? getVendorSelectedDetails(data.countryVendors, data.vendorQuoteDetails) : [],
        vendorSelectionDataCopy: data.vendorQuoteDetails && data.countryVendors ? getVendorSelectedDetails(data.countryVendors, data.vendorQuoteDetails) : [],
        selectVendorOption: data.selectVendorOption || "",
        vendorsList: data.vendorQuoteDetails ? Object.keys(data.vendorQuoteDetails) : [],
        rateCardType: data.rateCardType || "",
        vendorError: data.vendorError || "",
        countryError: data.countryError || "",
        backButtonFlag: false,
        fileUploadStatus: data.customerFormOrgFileName ? "success" : "",
        paymentOnePointOneDefaultMargins: getCountryCostMargins("payment1.1", data.countryCostMargins) || [],
        paymentOnePointOneMarginData: getCountryCostMargins("payment1.1", data.countryCostMargins) || [],
        paymentOnePointODefaultMargins: getCountryCostMargins("payment1.0", data.countryCostMargins) || [],
        paymentOnePointOMarginData: getCountryCostMargins("payment1.0", data.countryCostMargins) || [],
        userSelectedVendor: data.selectedVendor || "",
        vendorMatrixSelections: [],
        vendorQuoteDetails: data.vendorQuoteDetails ? formatVendorDetails(data.vendorQuoteDetails, data) : [],
        countryVendorQuoteDetails: data.countryVendorQuoteDetails ? data.countryVendorQuoteDetails : {},
        countryCurrency: data.countryCurrency ? data.countryCurrency : {},
        updatedDate: data.updatedDate,
        quoteAcceptRejectDate: data.quoteAcceptRejectDate || "",
        winningDeliveryPartner: Array.isArray(data.winningDeliveryPartner)
            ? data.winningDeliveryPartner.filter(partner => partner !== null)
            : (data.winningDeliveryPartner || []),
        quotationSubmissionDate: data.quotationSubmissionDate || "",
        selectedCountryVendor: data.selectedCountryVendor || "",
        selectedVendorMaxNetValue: data.selectedVendorMaxNetValue || "",
        convertedVendorNetValues: [],
        hprevitalizeStatus: data.hprevitalizeStatus || "",
        hpHarwareBuyBackValue: data.hpHarwareBuyBackValue || null,
        hpFormFileNameForRevilitize: data.hpFormFileNameForRevilitize || "",
        vhardwareRevitalizeFees: data.vhardwareRevitalizeFees,
        revitalizeCountries: data.revitalizeCountries || "",
        revCountryList: data.revCountryList || [],
        numberOfRevitalizeAssets: data.numberOfRevitalizeAssets || "",
        revitalizeHPPrices: data.revitalizeHPPrice || "",
        hpFileUploadStatus: data.hpFileUploadStatus || "",
        vpartialPriceProvided: data.vpartialPriceProvided || false,
        partialCreatedQuoteFileAvailable: data.partialCreatedQuoteFileAvailable || false,
        numberOfRevitalizeCountry: data.numberOfRevitalizeCountry || null,
        vhardwareRevitalizeCost: data.vhardwareRevitalizeCost || null,
        quoteType: data.quoteType || "",
        priceService: data.priceService || {},
        fmvDetails: data.fmvDetails || [],
        pyxtechCountryVendorDetails: data.pyxtechCountryVendorDetail ? Object.values(data.pyxtechCountryVendorDetail) : [],
        vendorAdditionalComments: data.vendorAdditionalComments || {},
        internalHPComments: data.internalHPComments || "",
        companyOrgIdEditable: data.companyOrgIdEditable || false
    });
};

const setRefusedVendors = (state = initialState, action) => {
    const data = action.payload;
    return updateObject(state, {
        refusedVendors: data
    });
}

const getCountryCostMargins = (paymentType, countryMargins) => {
    return countryMargins && countryMargins.filter(margin => paymentType === margin.paymentType);
}

const getVendorSelectedDetails = (countryVendors, vendorHeaders) => {
    const vendorSelection = {};
    vendorSelection.countryVendors = countryVendors;
    vendorSelection.vendorHeaders = Object.keys(vendorHeaders);
    return transformCountryVendorData(vendorSelection);
}

const formatVendorDetails = (vendorQuoteDetails, data) => {
    let arr = [];
    for (const [key, value] of Object.entries(vendorQuoteDetails)) {
        let obj = { ...value };

        obj.quotingPartners = key;
        obj.vhwBuyBackValue = data.vhwBuyBackValue;
        obj.rateCardType = data.rateCardType;
        obj.quotationNumber = data.quoteId;
        obj.currencyCode = "USD";
        obj.followUpFlag = value.followUpVendorPrice === "YES" ? true : value.followUpVendorPrice === "NO" ? false : true;
        arr.push(obj);
    }
    return arr;
}

const getRateCardSelection = (data) => {
    let value = "";
    if ((data.rateCardOption === null || data.rateCardOption === "customer_specific") && data.priceList) {
        value = "hardware_service";
    } else if (data.servicePriceList && data.rateCardOption === "vendor_specific") {
        value = "service_customquoteforhardware";
    } else {
        value = "vendor_specific";
    }
    return value;
}

// const getPriceList = (data) => {
//     let value = "";
// }

const updateQuoteValue = (state = initialState, action) => {
    const { name, value } = action.data;
    if (state.hasOwnProperty(name)) {
        return updateObject(state, {
            [name]: value
        });
    }
    return state;
}

const setVendorList = (state = initialState, action) => {
    return updateObject(state, {
        vendorsList: action.data
    });
}

const updateCountryList = (state = initialState, action) => {
    return updateObject(state, {
        countryList: action.data
    });
}
const updateRefusedReasonList = (state = initialState, action) => {
    return updateObject(state, {
        refusedReasonList: action.payload
    });
}

const setVendorSelectionData = (state = initialState, action) => {
    const { vendorData, needsTransformation, constructVendorDataCopy = false } = action.data;
    const transformedData = needsTransformation ? transformCountryVendorData(vendorData) : vendorData;
    const vendorSelectionDataCopy = constructVendorDataCopy ? transformedData : state.vendorSelectionDataCopy;
    return updateObject(state, {
        vendorSelectionData: needsTransformation ? transformCountryVendorData(vendorData) : vendorData,
        vendorSelectionDataCopy
    });
}

const setVendorSelection = (state = initialState, action) => {
    return updateObject(state, {
        selectVendorOption: action.data
    });
}

const setCTInitialQuoteField = (state = initialState, action) => {
    return updateObject(state, {
        [action.data.id]: action.data.value
    });
}

const setRateCardSelection = (state = initialState, action) => {
    return updateObject(state, {
        rateCardSelection: action.data
    });
}

const setRateConversionSelection = (state = initialState, action) => {
    return updateObject(state, {
        conversionRateType: action.data
    });
}

const updatePaymentOnePointOneMarginData = (state = initialState, action) => {
    return updateObject(state, {
        paymentOnePointOneMarginData: action.data
    });
}

const updatePaymentOnePointOMarginData = (state = initialState, action) => {
    return updateObject(state, {
        paymentOnePointOMarginData: action.data
    });
}

const backButtonStatus = (state = initialState, action) => {
    return updateObject(state, {
        backButtonFlag: action.data
    });
}

const setCTInitialQuoteSaveSuccess = (state = initialState, action) => {
    return updateObject(state, {
        directQuoteSaveSuccess: true,
        directQuoteSaveActionType: action.data,
    });
}

const setCTInitialQuoteData = (state = initialState, action) => {
    return updateObject(state, {
        directQuoteData: action.data
    });
}

const resetQuoteData = (state = initialState) => {
    return updateObject(initialState, {
        quoteGeneralData: updateObject(initialState, {
            ctResponsible: state.ctResponsible
        })
    });
}

const setVendorMatrixSelections = (state = initialState, action) => {
    return updateObject(state, {
        vendorMatrixSelections: action.data
    });
}

const setVendorNetValues = (state = initialState, action) => {
    return updateObject(state, {
        vendorNetValues: action.data
    });
}

const setUserSelectedTotalVendorNetValue = (state = initialState, action) => {
    return updateObject(state, {
        userSelectedTotalVendorNetValue: action.data
    });
}

const setConvertedVendorNetValues = (state = initialState, action) => {
    return updateObject(state, {
        convertedVendorNetValues: action.data
    });
}

const setQuoteId = (state = initialState, action) => {
    return updateObject(state, {
        quoteId: action.data
    });
}

const setFileUploadStatus = (state = initialState, action) => {
    return updateObject(state, {
        fileUploadStatus: action.data
    });
}

const setFileUploadStatusDesc = (state = initialState, action) => {
    return updateObject(state, {
        fileUploadStatusDesc: action.data.value
    });
}

const updateTableData = (state = initialState, action) => {
    const { name, value } = action.data;
    if (state.hasOwnProperty(name)) {
        return updateObject(state, {
            [name]: value
        });
    }
    return state;
}

const setUserSelectedVendor = (state = initialState, action) => {
    return updateObject(state, {
        userSelectedVendor: action.data
    });
}

const setVendorError = (state = initialState, action) => {
    return updateObject(state, {
        vendorError: action.data
    });
}

const setCountryError = (state = initialState, action) => {
    return updateObject(state, {
        countryError: action.data
    });
}

const setMaxNetValue = (state = initialState, action) => {
    return updateObject(state, {
        maxNetValue: action.data
    });
}

const updateFollowupFlag = (state = initialState, action) => {
    const { switcherState, vendorName } = action.data;
    const { vendorQuoteDetails } = state;
    vendorQuoteDetails.map((element, index) => {
        if (element.quotingPartners === vendorName) {
            vendorQuoteDetails[index] = { ...vendorQuoteDetails[index], followUpFlag: switcherState }
        }
    });
    return updateObject(state, { vendorQuoteDetails: vendorQuoteDetails });
}

const updateRefusedFlag = (state = initialState, action) => {
    const { vendorQuoteDetails } = state;
    vendorQuoteDetails.map((element, index) => {
        if (element.quotingPartners === action.data.vendorName) {
            vendorQuoteDetails[index] = { ...vendorQuoteDetails[index], refused: action.data.refused || false }
        }
    });
    return updateObject(state, { vendorQuoteDetails: vendorQuoteDetails });
}

const updateRefusedReason = (state = initialState, action) => {
    const { vendorQuoteDetails } = state;
    vendorQuoteDetails.map((element, index) => {
        if (element.quotingPartners === action.data.vendorName) {
            vendorQuoteDetails[index] = { ...vendorQuoteDetails[index], refusedReason: action.data.refusedReason || false }
        }
    });
    return updateObject(state, { vendorQuoteDetails: vendorQuoteDetails });
}

const reducer = (state = initialState, action) => {
    if (action.type === "SET_QUOTE_ID") {
        return setQuoteId(state, action)
    }
    if (action.type === "SET_CT_INITIAL_QUOTE_DETAIL") {
        return setCTInitialQuoteDetail(state, action);
    }
    else if (action.type === "SET_REFUSED_VENDORS") {
        return setRefusedVendors(state, action);
    }
    else if (action.type === "SET_CT_INITIAL_QUOTE_DETAIL_FIELD") {
        return updateQuoteValue(state, action);
    }
    if (action.type === "UPDATE_CT_INITIAL_QUOTES_COUNTRY_LIST") {
        return updateCountryList(state, action);
    }
    if (action.type === 'SET_CT_INITIAL_QUOTE_VENDOR_LIST') {
        return setVendorList(state, action);
    }
    if (action.type === 'SET_CT_INITIAL_QUOTES_VENDOR_DATA') {
        return setVendorSelectionData(state, action);
    }
    if (action.type === "SET_CT_INITIAL_QUOTES_VENDOR_SELECTION") {
        return setVendorSelection(state, action)
    }
    if (action.type === "SET_CT_INITIAL_QUOTE_FIELD") {
        return setCTInitialQuoteField(state, action)
    }
    if (action.type === "SET_CT_INITIAL_QUOTES_RATE_CARD_SELECTION") {
        return setRateCardSelection(state, action)
    }
    if (action.type === "SET_CT_INITIAL_QUOTES_RATE_CONVERSION_SELECTION") {
        return setRateConversionSelection(state, action)
    }
    if (action.type === "UPDATE_CT_INITIAL_QUOTES_PAYMENT_ONE_POINT_ONE_MARGIN_DATA") {
        return updatePaymentOnePointOneMarginData(state, action);
    }
    if (action.type === "UPDATE_CT_INITIAL_QUOTES_PAYMENT_ONE_POINT_O_MARGIN_DATA") {
        return updatePaymentOnePointOMarginData(state, action);
    }
    if (action.type === "BACK_BUTTON_CLICKED") {
        return backButtonStatus(state, action)
    }
    if (action.type === "SET_NEW_CT_INITIAL_QUOTE_CREATED") {
        return setCTInitialQuoteData(state, action);
    }
    if (action.type === 'SET_NEW_CT_INITIAL_QUOTE_SAVED') {
        return setCTInitialQuoteSaveSuccess(state, action);
    }
    if (action.type === 'RESET_CT_INITIAL_QUOTE_DATA') {
        return resetQuoteData(state);
    }
    if (action.type === 'SET_VENDOR_MATRIX_SELECTIONS') {
        return setVendorMatrixSelections(state, action);
    }
    if (action.type === 'SET_VENDOR_NET_VALUES') {
        return setVendorNetValues(state, action);
    }
    if (action.type === 'SET_USER_SELECTED_TOTAL_VENDOR_NET_VALUE') {
        return setUserSelectedTotalVendorNetValue(state, action);
    }
    if (action.type === 'SET_CONVERTED_VENDOR_NET_VALUES') {
        return setConvertedVendorNetValues(state, action);
    }
    if (action.type === "SET_FILE_UPLOAD_STATUS") {
        return setFileUploadStatus(state, action)
    }
    if (action.type === "SET_FILE_UPLOAD_STATUS_DESC") {
        return setFileUploadStatusDesc(state, action)
    }
    if (action.type === 'UPDATE_TABLE_DATA') {
        return updateTableData(state, action);
    }
    if (action.type === 'SET_USER_SELECTED_VENDOR') {
        return setUserSelectedVendor(state, action);
    }
    if (action.type === 'SET_VENDOR_ERROR') {
        return setVendorError(state, action);
    }
    if (action.type === 'SET_COUNTRY_ERROR') {
        return setCountryError(state, action);
    }
    if (action.type === 'SET_MAX_NET_VALUE') {
        return setMaxNetValue(state, action);
    }
    if (action.type === 'UPDATE_FOLLOW_UP_FLAG_TOGGLE') {
        return updateFollowupFlag(state, action);
    }
    if (action.type === 'UPDATE_REFUSED_FLAG') {
        return updateRefusedFlag(state, action);
    }
    if (action.type === 'UPDATE_REFUSED_REASON') {
        return updateRefusedReason(state, action);
    }
    if (action.type === "SET_REFUSED_REASON_LIST") {
        return updateRefusedReasonList(state, action);
    }
    return state;
}

export default reducer;